import { Heart, Activity, Car, Flower2, Users, Landmark, Shield } from "lucide-react";

const DEFAULT_ICONS = { life: Heart, health: Activity, casualty: Car, final_needs: Flower2, group: Users, business_loans: Landmark };

// Live taxonomy stores — seeded with defaults and hydrated at runtime from
// /api/options so SuperAdmin edits flow through the whole app.
export const CATEGORIES = {
  life: { label: "Life", color: "#2563EB", icon: Heart },
  health: { label: "Health", color: "#10B981", icon: Activity },
  casualty: { label: "Casualty", color: "#8B5CF6", icon: Car },
  final_needs: { label: "Final Needs", color: "#F59E0B", icon: Flower2 },
  group: { label: "Group Insurance", color: "#EC4899", icon: Users },
  business_loans: { label: "Business Loans", color: "#0EA5E9", icon: Landmark },
};

export const STATUSES = {
  new: { label: "New", color: "#3B82F6" },
  contacted: { label: "Contacted", color: "#F59E0B" },
  quoted: { label: "Quoted", color: "#8B5CF6" },
  closed_won: { label: "Closed Won", color: "#10B981" },
  closed_lost: { label: "Closed Lost", color: "#EF4444" },
};

export const TEMPERATURES = {
  cold: { label: "Cold", color: "#3B82F6" },
  warm: { label: "Warm", color: "#F59E0B" },
  hot: { label: "Hot", color: "#EF4444" },
  not_sure: { label: "Not Sure", color: "#94A3B8" },
};

export const CATEGORY_LIST = Object.keys(CATEGORIES);
export const STATUS_LIST = Object.keys(STATUSES);
export const TEMPERATURE_LIST = Object.keys(TEMPERATURES);

const rebuild = (target, list, items, withIcon) => {
  Object.keys(target).forEach((k) => delete target[k]);
  list.length = 0;
  items.forEach((it) => {
    target[it.key] = { label: it.label, color: it.color, ...(withIcon ? { icon: DEFAULT_ICONS[it.key] || Shield } : {}) };
    list.push(it.key);
  });
};

// Mutates the shared exports in place so already-imported references update.
export const hydrateOptions = (data) => {
  if (data?.insurance_types?.length) rebuild(CATEGORIES, CATEGORY_LIST, data.insurance_types, true);
  if (data?.lead_statuses?.length) rebuild(STATUSES, STATUS_LIST, data.lead_statuses, false);
  if (data?.lead_temperatures?.length) rebuild(TEMPERATURES, TEMPERATURE_LIST, data.lead_temperatures, false);
};

export const fmtMoney = (n) =>
  n == null ? "—" : `$${Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

// Live US-currency formatting for text inputs: displays "$1,200", stores raw digits.
export const formatCurrencyInput = (v) => {
  const digits = String(v ?? "").replace(/[^0-9]/g, "");
  return digits ? `$${Number(digits).toLocaleString("en-US")}` : "";
};
export const parseCurrencyInput = (v) => String(v ?? "").replace(/[^0-9]/g, "");
